export default __webpack_public_path__ + "static/media/3.11.adc0a51c.mp3";